import { create } from 'zustand';

/**
 * サイドバーのアコーディオン開閉状態を管理するストア。
 * ページ遷移してもアコーディオンの開閉状態を維持するため、
 * コンポーネントのローカルステートではなくZustandで管理する。
 */
interface SidebarState {
  /** 現在展開されているアコーディオンのインデックス配列 */
  expandedIndices: number[];
  /** 初回のURLベース初期化が完了したかどうかのフラグ */
  isInitialized: boolean;
  /** ユーザー操作によるアコーディオン開閉時に呼ばれる更新関数 */
  setExpandedIndices: (indices: number[]) => void;
  /** 初回マウント時のみURLから初期値をセットする関数（2回目以降は何もしない） */
  initialize: (indices: number[]) => void;
}

export const useSidebarState = create<SidebarState>((set) => ({
  expandedIndices: [],
  isInitialized: false,
  setExpandedIndices: (indices) =>
    set({ expandedIndices: indices, isInitialized: true }),
  /** 初回のみisInitializedフラグで反映し、以降のページ遷移では状態を維持する */
  initialize: (indices) =>
    set(
      (state) =>
        state.isInitialized
          ? state // 初期化済みなら何もせず現在の状態を返す
          : { expandedIndices: indices, isInitialized: true } // 初回のみ初期値をセット
    ),
}));
